module.exports = __webpack_public_path__ + "img/Recurso 3-.0b2be183.png";